/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import capitalize from 'underscore.string/capitalize';
import { Link } from 'react-router-dom';
import KeyprIcon from '@keypr/icon-font';
import SwipeableViews from 'react-swipeable-views';

import RequestQuickStatus from './RequestQuickStatus';
import TimeAge from '../../components/Filters/TimeAge';
import DeliveryTime from '../../components/Filters/DeliveryTime';
import { ServiceConfigType, RequestType, ChannelType } from './types';
import { localize } from '../../i18n';

import './RequestCard.css';

class RequestCard extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      opened: false,
    };
  }

  close() {
    if (this.state.opened) {
      this.setState({ opened: false });
    }
  }

  render() {
    const { request, channel, serviceConfig, onOpen, groupType } = this.props;
    const { opened } = this.state;
    const isDoneType = groupType === 'done';

    const channelColor = {
      borderLeft: '4px solid',
      borderLeftColor: channel && channel.dashboard_color,
    };

    const greyOutStyle = isDoneType ? { backgroundColor: '#a9a9a9' } : {};

    const backgroundColorChart = {
      warning: 'md-card-bg-warning',
      critical: 'md-card-bg-danger',
    };

    const ukBadge = {
      new: 'uk-badge-danger',
      acknowledged: 'uk-badge-warning',
      assigned: 'uk-badge-warning',
      resolved: 'uk-badge-success',
      cancelled: 'uk-badge-primary',
      closed: 'uk-badge-primary',
      unknown: '',
    };

    const cardCls = ['md-card'];
    const cardBarCls = ['md-card-toolbar'];
    const ukBadgeCls = ['uk-badge'];
    if (request.severity in backgroundColorChart) {
      cardCls.push(backgroundColorChart[request.severity]);
    } else {
      cardCls.push('md-card-bg-success');
    }
    ukBadgeCls.push(ukBadge[request.status || 'unknown']);

    const requestCloseOthers = (index) => {
      this.setState({ opened: index === 1 });
      return ((index === 1) ? onOpen(request) : null);
    };

    const requestDetailsLink = {
      pathname: `/access/requests/${request._id}/details`,
      state: { request, channel, serviceConfig },
    };

    return (
      <div className="uk-margin-medium-top">
        <SwipeableViews index={opened ? 1 : 0} onChangeIndex={requestCloseOthers}>
          <div>
            <Link to={requestDetailsLink}>
              <div className={cardCls.join(' ')} style={channelColor}>
                <div className={cardBarCls.join(' ')} style={greyOutStyle}>
                  <div className="md-card-toolbar-actions">
                    <div className="uk-grid">
                      <div className="uk-grid-width-medium-1-2">
                        <TimeAge time={request._created} />
                      </div>
                    </div>
                  </div>
                  <h3 className="md-card-toolbar-heading-text">
                    <span className="md-card-toolbar-icon">
                      <KeyprIcon icon={serviceConfig.service_icon} className="service-icon" />
                    </span>
                    <span className="md-card-toolbar-title">{request.label}</span>
                  </h3>
                </div>
                <div className="md-card-content">
                  <p className="uk-text-large"><b>#{request.room}</b> {this.props.t('for')} {request.guest_name}</p>
                  <div className="uk-float-right uk-margin-small-right">
                    <div className="uk-text-small">{this.props.t('Request Status')}</div>
                    <div className="uk-text-nowrap uk-text-right">
                      <span className={ukBadgeCls.join(' ')}>{this.props.t(capitalize(request.status))}</span>
                    </div>
                  </div>
                  <DeliveryTime
                    epochs={request.epochs}
                    className="delivery-time uk-text-small"
                  />
                </div>
              </div>
            </Link>
          </div>
          <div className="RequestCardOverlay">
            <div className="md-card">
              <div className="md-card-content">
                <p className="uk-text-large">
                  <KeyprIcon icon={serviceConfig.service_icon} className="service-icon" />
                  <span className="RequestTitle">{request.label}</span>
                </p>
                <p className="uk-text-large uk-margin-small-top"><b>#{request.room}</b> {this.props.t('for')} {request.guest_name}</p>
                <RequestQuickStatus request={request} onAction={() => this.close()} />
              </div>
            </div>
          </div>
        </SwipeableViews>
      </div>
    );
  }
}

RequestCard.propTypes = {
  request: RequestType,
  serviceConfig: ServiceConfigType,
  channel: ChannelType,
  onOpen: PropTypes.func,
  groupType: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default localize(RequestCard);



// WEBPACK FOOTER //
// ./src/views/requests/RequestCard.js